<mat-nav-list class="nav-list">
  <!-- Accueil - Only for USER role -->
  <!-- <mat-list-item
    *ngIf="isEtabSelected && isUserRole"
    routerLink="/accueil"
    class="nav-item"
    (click)="onItemClick()"
    [disableRipple]="true"
  >
    <mat-icon matListItemIcon class="icon-color" [ngStyle]="{'color': '#4CAF50'}">home</mat-icon>
    <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.WELCOME' | translate }}</span>
  </mat-list-item> -->

  <!-- Subjects - Only for USER role -->
  <mat-list-item
    *ngIf="isEtabSelected && isUserRole"
    routerLink="/subject"
    class="nav-item"
    (click)="onItemClick()"
    [disableRipple]="true"
  >
    <mat-icon matListItemIcon class="icon-color" [ngStyle]="{'color': '#4CAF50'}">category</mat-icon>
    <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.SUBJECTS_LIST' | translate }}</span>
  </mat-list-item>
  <!-- Dashboard -->
  <mat-list-item *ngIf="isEtabSelected && isAdminOrSuperAdmin" routerLink="/dashboard" class="nav-item" (click)="onItemClick()" [disableRipple]="true">
    <mat-icon matListItemIcon class="icon-color" [ngStyle]="{'color': '#3F51B5'}">dashboard</mat-icon>
    <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.DASHBOARD' | translate }}</span>
  </mat-list-item>

  <!-- Donations - Only for USER role -->
  <mat-list-item
    *ngIf="isEtabSelected && isUserRole"
    routerLink="/donations"
    class="nav-item"
    (click)="onItemClick()"
    [disableRipple]="true"
  >
    <mat-icon matListItemIcon class="icon-color" [ngStyle]="{'color': '#4CAF50'}">volunteer_activism</mat-icon>
    <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.DONATION_LIST' | translate }}</span>
  </mat-list-item>
  <!-- Section Familles - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedFam"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('fam')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#2196F3'}">group</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.FAMILIES' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/list-famille" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#42A5F5'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.FAMILY_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/create-famille" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#42A5F5'}">add_circle</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_FAMILY' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/list-archived" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#42A5F5'}">archive</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ARCHIVED_LIST' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Bénéficiaires - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedE"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('bene')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#FF9800'}">child_care</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.BENEFICIARIES' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/inscrit" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#FFB300'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.BENEFICIARY_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/edit-inscrit/XX" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#FFB300'}">person_add</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_BENEFICIARY' | translate: { value: inscritsEnv } }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/inscrit-archived" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#42A5F5'}">archive</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ARCHIVED_LIST' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Personnel - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedPers"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('pers')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#9C27B0'}">people</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.PERSONNEL' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/personnel" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#AB47BC'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.PERSONNEL_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/nouveau-personnel/XX" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#AB47BC'}">person_add</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_PERSONNEL' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/personel-archived" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#42A5F5'}">archive</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ARCHIVED_LIST' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Dépenses - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedSt"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('dep')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#F44336'}">money_off</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.EXPENSES' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/list-sortie" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#EF5350'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.EXPENSE_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/nouveau-payement-per/0" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#EF5350'}">add_circle</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_EXPENSE' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Revenus - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedEnt"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('rec')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#4CAF50'}">attach_money</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.INCOME' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/list-entree" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#66BB6A'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.INCOME_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/nouveau-payement/XX" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#66BB6A'}">add_circle</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_INCOME' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Statistiques - Only for ADMIN and SUPER_ADMIN -->
  <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedStat"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('stat')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#3F51B5'}">bar_chart</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.STATISTICS' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/list-mouvement" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#5C6BC0'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.FINANCIAL_STATS' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>

  <!-- Section Factures - Only for ADMIN and SUPER_ADMIN -->
  <!-- <mat-expansion-panel
    *ngIf="isEtabSelected && isAdminOrSuperAdmin"
    class="expansion-panel"
    [expanded]="!isCollapsedF"
    [disabled]="!isSidebarOpen && isLargeScreen"
    [disableRipple]="true"
  >
    <mat-expansion-panel-header (click)="toggleCollapse('fact')">
      <mat-icon class="icon-color" [ngStyle]="{'color': '#607D8B'}">receipt</mat-icon>
      <span class="panel-title" *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.INVOICES' | translate }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list class="sub-nav-list">
      <mat-list-item routerLink="/list-facture" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#78909C'}">list</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.INVOICE_LIST' | translate }}</span>
      </mat-list-item>
      <mat-list-item routerLink="/nouveau-facture" (click)="onItemClick()" [disableRipple]="true">
        <mat-icon matListItemIcon [ngStyle]="{'color': '#78909C'}">add_circle</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen || isMobile">{{ 'SIDEBAR.ADD_INVOICE' | translate }}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel> -->
</mat-nav-list>
